import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { FloatingPopupBarChartWrapperComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-bar-chart-wrapper/floating-popup-bar-chart-wrapper.component';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpLoggerNoiseHistogramStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram/fp-logger-noise-histogram.store';
import { FpLoggerNoiseHistogramChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram-chart.service';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-logger-noise-histogram-minimized',
  standalone: true,
  imports: [ElementWidthClassDirective, FloatingPopupBarChartWrapperComponent, FloatingPopupBaseErrorMessageComponent],
  templateUrl: './fp-logger-noise-histogram-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpLoggerNoiseHistogramMinimizedComponent {
  public readonly currentTabStore = inject(FpLoggerNoiseHistogramStore);
  protected readonly chartService = inject(FpLoggerNoiseHistogramChartService);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  private readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isChartDataExist = computed(() => !!this.data()?.length);

  public readonly loggerDeployment = computed(() => this.popupMainData()?.deployment);

  public readonly chartPlugins = [this.chartService.getXTicksPlugin()];

  public combinedChartData = computed(() => {
    const data = this.data() || [];
    const chartData = this.chartService.getMinimizedDataForChart(data);
    const chartOptions = this.chartService.generateMinimizedOptions({ spread: data[0]?.spread ?? null });
    return { chartData, chartOptions };
  });
}
